var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
define(["require", "exports", "hypo_bvo/Drklein/Shared/AgentService", "hypo_bvo/Drklein/Shared/OfficeAllocationService", "hypo_bvo/Drklein/ProfilKontaktformular/ProfilKontaktformular", "hypo_elements/Typescripts/UrlParameters/UrlParameters", "hypo_elements/Containers/Reitermodul/Reitermodul", "hypo_bvo/Drklein/GoogleMapsButton/GoogleMapsButton", "hypo_bvo/Drklein/ProfilUebermich/ProfilUebermich", "jquery"], function (require, exports, AgentService, OfficeAllocationService, ProfilKontaktformular, UrlParameters, Reitermodul) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    AgentService = __importStar(AgentService);
    OfficeAllocationService = __importStar(OfficeAllocationService);
    ProfilKontaktformular = __importStar(ProfilKontaktformular);
    UrlParameters = __importStar(UrlParameters);
    Reitermodul = __importStar(Reitermodul);
    AgentService.getAgent($(".profilInformation").data("uid")).done(function (agent) {
        $(function () {
            var officeAllocation = OfficeAllocationService.getOfficeAllocationForAgent(agent);
            agent.productGroups.forEach(setStorageForAllProductGroups);
            function setStorageForAllProductGroups(productGroup) {
                var storagePath = "hypoport.agent-storage.agent-office-allocation.";
                storagePath += productGroup.platformId;
                sessionStorage.setItem(storagePath, JSON.stringify(officeAllocation));
                localStorage.setItem(storagePath, JSON.stringify(officeAllocation));
            }
        });
    });
    var subStringOfAgentSearchPage = "/berater-vor-ort.html";
    var sourceOfThePageVisit = document.referrer;
    if (sourceOfThePageVisit.toLowerCase().indexOf(subStringOfAgentSearchPage) == -1) {
        Reitermodul.openTabByName("#profil-tab-kontaktformular");
    }
    if (window.location.hash) {
        Reitermodul.openTabByName(window.location.hash);
    }
    if (UrlParameters.getParameterByName("showContent") === "kontaktformular-ratenkredit") {
        ProfilKontaktformular.showKontaktformular("Ratenkredit");
        Reitermodul.openTabByName("#profil-tab-kontaktformular");
    }
});
